<app-item-base [open]="open" [showHeader]="false">
  <p class="name" placement="right">
    skill検索
  </p>

  <div class="keyword-body edit-field">
    <textarea #autoCompleteInput type="text" placeholder="スキル検索" [(ngModel)]="this.searchParams.required_skills"
      (ngModelChange)="skillCandidate.next($event)" name="skill_list_search"
      [matAutocomplete]="auto" placement="right" (blur)="onBlur()" (keydown)="EnterOnSearchBox($event)"></textarea>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="newRequest()">
      <mat-option *ngFor="let skill of skillCandidate$ | async" [value]="skill[0]+skill[1]">
        {{ skill[1] }}
      </mat-option>
    </mat-autocomplete>
    <button type="button" (click)="resetSearchSkillList()"><span></span></button>
  </div>

</app-item-base>